/* global React */
// Skin-velger. Eneste JSX-tillegg for skins: bakgrunnsmenyen i shell.jsx viser den
// med {window.SkinPicker && <window.SkinPicker/>}. Skinnet er et brukervalg for hele
// appen (ikke per side eller foretak) og settes som html[data-skin]; mørk variant
// styres av dark-knappen (html[data-dark]). Selve utseendet ligger i
// src/styles/skin-<navn>.css — se «Skins» i docs/architecture/design-refresh-migration.md.
(function (global) {
  const STORAGE_KEY = 'plumme-skin';
  const SKINS = [
    { key: 'standard', sw: '#A074E0', r: 7 },
    { key: 'klassisk', sw: '#164BFF', r: 5 },
  ];

  const readSkin = () => { try { return localStorage.getItem(STORAGE_KEY) || 'standard'; } catch (e) { return 'standard'; } };
  const applySkin = (key) => {
    if (key && key !== 'standard') document.documentElement.dataset.skin = key;
    else delete document.documentElement.dataset.skin;
  };
  applySkin(readSkin());

  function SkinPicker() {
    const [skin, setSkin] = React.useState(readSkin);
    const pick = (key) => { setSkin(key); applySkin(key); try { localStorage.setItem(STORAGE_KEY, key); } catch (e) {} };
    return <React.Fragment>
      <div className="skin-sep"/>
      <div className="bg-theme-title">{t('skin.title')}</div>
      <div className="bg-theme-grid">{SKINS.map((s) =>
        <button key={s.key} className={'bg-theme-opt skin-opt' + (skin === s.key ? ' active' : '')} onClick={() => pick(s.key)}>
          <span className="bg-theme-sw" style={{ background: s.sw, borderRadius: s.r }}>Aa</span>
          <span>{t('skin.' + s.key)}<span className="skin-opt-sub">{t('skin.' + s.key + 'Sub')}</span></span>
        </button>)}</div>
    </React.Fragment>;
  }
  global.SkinPicker = SkinPicker;
})(window);
